import { CaseManagerDetails } from '../../type';
import { useChannel } from './useChannelHooks';
import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';

export const useCcmDetails = (channelGuid: string): CaseManagerDetails[] => {
  const channel = useChannel(channelGuid);
  const patientGuid = channel?.attributes.patientGuid;
  return useCareTeamSelector(
    useCallback(
      (state) => {
        if (state === 'LOADING' || !patientGuid) {
          return [];
        }
        return state.ccmDetails[patientGuid] ?? [];
      },
      [patientGuid],
    ),
  );
};
